import { forEach, has, isObject, toLower } from "lodash";
import dayjs from "dayjs";

export const toOptions = (data, label = "name", value = "_id") => {
  let result = [];
  forEach(data, item => {
    if (has(item, value)) {
      result.push({
        label: item[label],
        value: item[value]
      });
    }
  });
  return result;
};

export function vh(v, offset = 0) {
  var h = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0
  );
  return (v * h) / 100 - offset;
}

export function formatNumber(num) {
  if (num) {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  }
  return num;
}

export function stringToSlug(str) {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  // Some system encode vietnamese combining accent as individual utf-8 characters
  // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
  // Remove extra spaces
  // Bỏ các khoảng trắng liền nhau
  str = str.replace(/ /g, "");
  str = str.trim();
  return str;
}

export function base64ToArrayBuffer(base64) {
  let binary_string = atob(base64);
  let bytes = new Uint8Array(binary_string.length);
  for (let i = 0; i < binary_string.length; i++) {
    bytes[i] = binary_string.charCodeAt(i);
  }
  return bytes;
}

export function capitalize(value) {
  if (!value) {
    return "";
  }
  value = value.toString();
  return value.charAt(0).toUpperCase() + value.slice(1);
}

export function capitalizeAllProperNouns(value) {
  if (!value) {
    return "";
  }
  let splitStr = value.toLowerCase().split(" ");
  for (let i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(" ");
}

export function toCurrency(value) {
  if (!value) return value;
  return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function formatDate(
  value,
  defaultValue = "",
  format = "YYYY-MM-DD HH:mm:ss"
) {
  if (!value) return defaultValue;
  return dayjs(value).format(format);
}

export const convertMinuteToHourMinute = totalMinutes => {
  let hours = Math.floor(totalMinutes / 60);
  let minutes = totalMinutes % 60;
  let second = (totalMinutes - Math.floor(totalMinutes)) * 60;
  return `${hours < 10 ? `0${parseInt(hours)}` : parseInt(hours)}:${
    parseInt(minutes) < 10 ? `0${parseInt(minutes)}` : parseInt(minutes)
  }:${parseInt(second) < 10 ? `0${parseInt(second)}` : parseInt(second)}`;
};

export const convertSecondToHourMinute = totalSecond => {
  let totalMinutes = totalSecond / 60;
  return convertMinuteToHourMinute(totalMinutes);
};

export const filterOption = (input, optionValue) => {
  if (isObject(optionValue)) {
    return (
      toLower(stringToSlug(optionValue.label)).indexOf(
        toLower(stringToSlug(input))
      ) >= 0
    );
  }
  return (
    toLower(stringToSlug(optionValue)).indexOf(toLower(stringToSlug(input))) >=
    0
  );
};

export const convertMinuteToHourMinuteString = totalMinutes => {
  let hours = Math.floor(totalMinutes / 60);
  let minutes = totalMinutes % 60;
  let second = (totalMinutes - Math.floor(totalMinutes)) * 60;
  return `${hours < 10 ? `0${parseInt(hours)}` : parseInt(hours)} giờ ${
    parseInt(minutes) < 10 ? `0${parseInt(minutes)}` : parseInt(minutes)
  } phút ${parseInt(second) < 10 ? `0${parseInt(second)}` : parseInt(second)} giây`;
};
